"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IsSigning = void 0;
const Field_type_1 = require("../../../types/Field.type");
exports.IsSigning = {
    priority: Number.MAX_VALUE,
    label: 'fields.payload.mor_entity_answers.is_signing.label',
    fallbackLabel: 'Is the provided single entity responsible for receiving the aggregated funds from Klarna in order to distribute them further to your merchants?',
    mandatory: (payload, path) => isMandatory(payload, path),
    disabled: (payload, path) => false,
    applicable: (payload, path) => isApplicable(payload, path),
    applicableDependsOn: ['contract_onboarding_type'],
    type: Field_type_1.FieldType.Boolean,
    trackFieldValueWithAnalytics: true,
};
function isMandatory(payload, path) {
    return (payload.contract_onboarding_type?.valueOf?.() === 'MOR_ONBOARDING_ENTITY');
}
function isApplicable(payload, path) {
    return (payload.contract_onboarding_type?.valueOf?.() === 'MOR_ONBOARDING_ENTITY');
}
